import React from "react";

const spotify = (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="m23.6875,7.20813l0,4.50721a0.90142,0.90142 0 0 1 -0.90144,0.90144a11.64258,11.64258 0 0 1 -5.40871,-1.31921l0.00006,4.02353a8.5637,8.5637 0 1 1 -10.07387,-8.43077a0.90139,0.90139 0 0 1 1.05946,0.88747l-0.00006,4.69191a0.90141,0.90141 0 0 1 -0.5146,0.81424a2.25391,2.25391 0 1 0 3.21898,2.03715l0,-14.42307a0.90142,0.90142 0 0 1 0.90144,-0.90144l4.50721,0a0.90142,0.90142 0 0 1 0.90144,0.90144a5.41478,5.41478 0 0 0 5.40865,5.40865a0.90142,0.90142 0 0 1 0.90144,0.90144z"/>
  </svg>
);
export default spotify;
